module.exports = __webpack_public_path__ + "static/emojitip-a382a4b9b3d9fcacf2ebb010a9bf827b.png";